import { SizeObjectProps } from "../commons/types/LogoTypes";

export const getLogoSizes: SizeObjectProps = ({ width, height }) => ({
  normal: { width, height },
  mid: { width: width / 1.5, height: height / 1.5 },
  small: { width: width / 2, height: height / 2 },
});
